function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-142 -195)"
}, React.createElement("circle", {
  cx: 16.71,
  cy: 16.71,
  r: 16.71,
  transform: "translate(142 195)",
  fill: "#55b261"
}), React.createElement("path", {
  d: "M0,6.742A6.508,6.508,0,0,1,3.4,3.069c.97.523,2.648,4.278,2.648,4.278s1.116-4,7.588-7.347A10.783,10.783,0,0,1,17.4,4.365c-1.506.8-9.94,4.2-11.849,7.029C4.387,10.241,3.127,7.758,0,6.742Z",
  transform: "translate(148.579 209.197) rotate(-19)",
  fill: "#fff"
}));

var SvgTickWithCircle = function SvgTickWithCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 33.42,
    height: 33.42,
    viewBox: "0 0 33.42 33.42",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTickWithCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tick-with-circle.3796d10b.svg";
export { ForwardRef as ReactComponent };